// React.
import React, {Fragment} from 'react';

// Material UI.
import Paper from '@material-ui/core/Paper';
import CssBaseline from '@material-ui/core/CssBaseline';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';

// Components.
import OrderList from '../orders/OrderList';

// Styles.
import useStyles from './OrdersStyles';

// Translations.
import { useTranslation } from 'react-i18next';


const Orders = () => {
  const classes = useStyles();
  const [t] = useTranslation('global');

  return (
    <Fragment>
      <CssBaseline />
      <Container maxWidth="md" className={classes.ordersWrapper}>
        <Paper elevation={3} square={false} variant="elevation" className={classes.paperWrapper}>
          <Typography gutterBottom variant="h5" component="h1" color="primary">
            { t('orders.my-orders') }
          </Typography>
          <OrderList/>
        </Paper>
      </Container>
    </Fragment>
  )
}

export default Orders;
